import React, { useState, FC } from "react";
import { Spin } from "antd";

interface ImageWithSpinnerProps {
  src: string;
  alt: string;
  className?: string;
  [x: string]: any;
}

const ImageWithSpinner: FC<ImageWithSpinnerProps> = ({
  src,
  alt,
  className,
  ...props
}) => {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => {
    setLoading(false);
  };

  return (
    <>
      {loading && (
        <Spin
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
        className={className}
        style={{ display: loading ? "none" : "block" }}
        {...props}
      />
    </>
  );
};

export default ImageWithSpinner;
